export function widthMeasures(state, data) {
  state.widthMeasures = data
}

export function heightMeasures(state, data) {
  state.heightMeasures = data
}

export function rimMeasures(state, data) {
  state.rimMeasures = data
}
